import { render, staticRenderFns } from "./RubricAccess.vue?vue&type=template&id=301f3664"
import script from "./RubricAccess.vue?vue&type=script&lang=js"
export * from "./RubricAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports